<template>
  <div class="password bl">
    <van-nav-bar :title="$t('setting.loginpwdtitle')" class="custom-nav-bar">
      <template #left>
        <van-icon name="arrow-left" @click="back()"/>
      </template>
    </van-nav-bar>
    
    <div class="content-wrapper">
      <div class="form-container">
        <div class="input-group">
          <div class="input-item">
            <div class="input-label">{{$t('setting.oldpwd')}}</div>
            <div class="input-field">
              <input :type="passwordType" v-model="old_password" class="van-field__control"
                :placeholder="$t('setting.oldpwd')">
              <div class="input-icon" @click="switchPasswordType">
                <van-icon :name="passwordType === 'password' ? 'closed-eye':'eye-o'" size="1.2rem"/>
              </div>
            </div>
          </div>

          <div class="input-item">
            <div class="input-label">{{$t('setting.newpwd')}}</div>
            <div class="input-field">
              <input :type="passwordType2" v-model="o_new_password" class="van-field__control" 
                :placeholder="$t('setting.newpwd')">
              <div class="input-icon" @click="switchPasswordType2">
                <van-icon :name="passwordType2 === 'password' ? 'closed-eye':'eye-o'" size="1.2rem"/>
              </div>
            </div>
          </div>

          <div class="input-item">
            <div class="input-label">{{$t('setting.renewpwd')}}</div>
            <div class="input-field">
              <input :type="passwordType3" v-model="t_new_password" class="van-field__control"
                :placeholder="$t('setting.renewpwd')">
              <div class="input-icon" @click="switchPasswordType3">
                <van-icon :name="passwordType3 === 'password' ? 'closed-eye':'eye-o'" size="1.2rem"/>
              </div>
            </div>
          </div>
        </div>
        
        <div class="btns" @click="save()">
          <a>{{$t('setting.change')}}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      o_new_password:"",
      t_new_password:"",
      old_password:"",
	  passwordType: 'password',
	  passwordType2: 'password',
	  passwordType3: 'password',
      userInfo:{}
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
	switchPasswordType() {
	  this.passwordType = this.passwordType === 'password' ? 'text' : 'password'
	},
	switchPasswordType2() {
	  this.passwordType2 = this.passwordType2 === 'password' ? 'text' : 'password'
	},
	switchPasswordType3() {
	  this.passwordType3 = this.passwordType3 === 'password' ? 'text' : 'password'
	},
    save(){
      if(this.o_new_password === "" || this.o_new_password === null || this.o_new_password === undefined){
        this.$toast.fail(this.$t('setting.plseall'));
        return false;
      }
      if(this.t_new_password === "" || this.t_new_password === null || this.t_new_password === undefined){
        this.$toast.fail(this.$t('setting.plseall'));
        return false;
      }
      if(this.old_password === "" || this.old_password === null || this.old_password === undefined){
        this.$toast.fail(this.$t('setting.plseall'));
        return false;
      }
      if(this.o_new_password !== this.t_new_password){
        this.$toast(this.$t('setting.pswwrong'));
        return false;
      }
      this.$http({
        method: 'get',
        data:{
          old_password:this.old_password,
          new_password:this.o_new_password,
        },
        url: 'user_set_loginpw'
      }).then(res=>{
        if(res.code === 200){
          this.$toast(res.msg);
          setTimeout(() => {
            localStorage.clear()
            this.$router.push("Login")
          }, 500);

        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res=>{
        if(res.code === 200){
          this.userInfo = res.data;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getUserInfo();
    }
  }
};
</script>

<style lang='less' scoped>
:export {
    gbcolor: linear-gradient(135deg, #3498db, #8e44ad)
}

.password {
    width: 100%;
    min-height: 100vh;
    background: white;
}

/* 顶部导航栏样式 - 填充渐变色 */
.custom-nav-bar {
    height: 3.5rem;
    line-height: 3.5rem;
    background: linear-gradient(135deg, #3498db 0%, #8e44ad 100%);
    position: relative;
    z-index: 10;
}

.custom-nav-bar::after {
    display: none;
}

.van-nav-bar__title {
    max-width: 60%;
    margin: 0 auto;
    color: white !important;
    font-weight: 600;
    font-size: 1.1rem;
}

.van-nav-bar__left {
    padding: 0 15px;
}

.van-nav-bar__left .van-icon {
    color: white !important;
    font-size: 1.2rem;
    font-weight: bold;
}

/* 内容区域 */
.content-wrapper {
    padding: 1.5rem 1rem;
    background: white;
}

.form-container {
    max-width: 100%;
}

/* 输入框组 */
.input-group {
    background: white;
}

/* 每个输入框带边框 */
.input-item {
    margin-bottom: 1rem;
    border: 1.5px solid #e8e8e8;
    border-radius: 12px;
    background: white;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
    transition: all 0.3s ease;
    overflow: hidden;
}

.input-item:focus-within {
    border-color: #667eea;
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.15);
}

.input-label {
    padding: 1rem 1.2rem 0.5rem;
    font-size: 0.95rem;
    font-weight: 500;
    color: #333;
    background: linear-gradient(135deg, #f8f9ff, #f0f2ff);
}

.input-field {
    display: flex;
    align-items: center;
    padding: 0.5rem 1.2rem 1rem;
    position: relative;
}

.van-field__control {
    flex: 1;
    border: none;
    outline: none;
    font-size: 1rem;
    color: #333;
    background: transparent;
    padding: 0.3rem 0;
}

.van-field__control::placeholder {
    color: #aaa;
    font-size: 0.9rem;
}

.input-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 2rem;
    height: 2rem;
    color: #667eea;
    cursor: pointer;
    border-radius: 4px;
    transition: all 0.3s ease;
    margin-left: 0.5rem;
}

.input-icon:active {
    background: rgba(102, 126, 234, 0.1);
    transform: scale(0.9);
}

/* 按钮样式 */
.btns {
    display: block;
    width: 100%;
    margin: 2rem auto 1rem;
    background: linear-gradient(135deg, #3498db, #8e44ad);
    color: #fff;
    padding: 1rem 0;
    border-radius: 12px;
    font-size: 1rem;
    font-weight: 500;
    cursor: pointer;
    text-align: center;
    border: none;
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
    transition: all 0.3s ease;
}

.btns:active {
    transform: translateY(2px);
    box-shadow: 0 2px 6px rgba(102, 126, 234, 0.4);
}

.btns a {
    color: white;
    text-decoration: none;
    display: block;
    width: 100%;
}

/* 动画效果 */
@keyframes fadeInUp {
    from { 
        opacity: 0; 
        transform: translateY(15px); 
    }
    to { 
        opacity: 1; 
        transform: translateY(0); 
    }
}

.input-item {
    animation: fadeInUp 0.4s ease forwards;
}

.input-item:nth-child(1) {
    animation-delay: 0.1s;
}

.input-item:nth-child(2) {
    animation-delay: 0.2s;
}

.input-item:nth-child(3) {
    animation-delay: 0.3s;
}

.btns {
    animation: fadeInUp 0.5s ease forwards;
    animation-delay: 0.4s;
}

/* 响应式调整 */
@media (max-width: 320px) {
    .content-wrapper {
        padding: 1rem 0.8rem;
    }
    
    .input-label {
        padding: 0.8rem 1rem 0.4rem;
        font-size: 0.9rem;
    }
    
    .input-field {
        padding: 0.4rem 1rem 0.8rem;
    }
    
    .van-field__control {
        font-size: 0.95rem;
    }
    
    .btns {
        padding: 0.9rem 0;
        font-size: 0.95rem;
        margin: 1.5rem auto 0.8rem;
    }
}

/* 移除旧样式 */
.van-cell-group {
    background: transparent;
    border: none;
}

.van-cell-group::after,
.van-cell-group::before {
    display: none;
}
</style>

